/*
 *  This has been generated using the Synergy STDev tool.
 *  Any modifications will be lost after the next build
 */
import * as st from './STApp'
import { componentApi, loadTranslations } from 'common'


export class RecurPatternApi {
  async GetNextRecurDate(recur : st.Recur) : Promise<string> {
    return await componentApi.call('st', 'st-recur-pattern', 'RecurPatternApi', 'GetNextRecurDate', {
      recur,
    });
  }
}
export default new RecurPatternApi()
